'use strict';

$ = jQuery;

/*
* Evento de clique em navegação de análise
*/
$('.navbar a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Navegação',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Navegação',
    'eventLabel': $(this).text()
  });
});

/*
* Evento de clique nas versões
*/
$('.jc-model-versions').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Versão',
    'eventLabel': $(this).val()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Versão',
    'eventLabel': $(this).val()
  });
});